// @flow

import React from 'react';

const ModalActions = ({ children }: {children: React.Node}) => (
    <>
        { children }
    </>
);


export default ModalActions;
